import { styled } from "@styles";

export const Checkbox = styled.label`
  width: 100%;
  margin-bottom: 1.25rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  position: relative;
  margin-left: -4px;

  input[type="checkbox"] {
    height: 1px;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    width: 1px;
  }

  input:focus-visible + span div {
    border-radius: 50%;
    border: 1px solid;
    outline: 2px solid ${props => props.theme.colors.secondary};
    outline-offset: 2px;
    border-color: ${props => props.theme.colors.secondaryOverlayDark};
    background-color: ${props => props.theme.colors.secondaryOverlayDark};
  }

  input:checked + span div span {
    background-clip: content-box;
    padding: 2px;
    background-color: ${props => props.theme.colors.secondary};
  }
`;

export const Label = styled.span`
  display: flex;
  cursor: pointer;
  justify-content: flex-start;
  align-items: center;
  padding-right: 1.25rem;

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 26px;
    width: 26px;

    span {
      border: 1px solid ${props => props.theme.colors.secondary};
      width: 14px;
      height: 14px;
      display: inline-block;
    }

    ${Checkbox}:hover & {
      border-radius: 50%;
      border: 1px solid;
      border-color: ${props => props.theme.colors.secondaryOverlay};
      background-color: ${props => props.theme.colors.secondaryOverlay};
    }

    :focus {
      border-radius: 50%;
      border: 1px solid;
      outline: none;
      border-color: ${props => props.theme.colors.secondaryOverlayDark};
      background-color: ${props => props.theme.colors.secondaryOverlayDark};
    }
  }
`;

export const Text = styled.span``;
